import { type Metric } from '../vessel_data'

export enum GearboxMetric {
  gearboxPortRpmIn = 'gearboxPortRpmIn',
  gearboxPortRpmOut = 'gearboxPortRpmOut',
  gearboxStbdRpmIn = 'gearboxStbdRpmIn',
  gearboxStbdRpmOut = 'gearboxStbdRpmOut',
}

export type GearboxMetricName = keyof typeof GearboxMetric

export type GearboxMetrics = Record<GearboxMetricName, Metric>

export const allGearboxMetricNames: GearboxMetricName[] = Object.values(GearboxMetric)
